import { render, staticRenderFns } from "./armsChooser.vue?vue&type=template&id=3d0fa60b&scoped=true"
import script from "./armsChooser.vue?vue&type=script&lang=js"
export * from "./armsChooser.vue?vue&type=script&lang=js"
import style0 from "./armsChooser.vue?vue&type=style&index=0&id=3d0fa60b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0fa60b",
  null
  
)

export default component.exports